var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('head-top',{attrs:{"navActive":_vm.navActive}}),_vm._v(" "),_c('div',{staticClass:"description-first-bg"}),_vm._v(" "),_c('div',{staticClass:"flow-path"},_vm._l((_vm.innerHtmlList),function(item){return _c('div',{key:item.id},[_c('div',{})])}),0),_vm._v(" "),_c('foot-bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47fd92d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/description-second.vue
// module id = null
// module chunks = 